module.exports = __webpack_public_path__ + "img/female.060f9a2b.png";